export const apiConfig = {
    API_END_POINT: "",
    REACT_APP_CRYPTOPASSWORD: process.env.REACT_APP_CRYPTOPASSWORD,
    REACT_APP_STRIPEPUBLISHABLEKEY: process.env.REACT_APP_STRIPEPUBLISHABLEKEY,
    REACT_APP_STRIPESECRETKEY: process.env.REACT_APP_STRIPESECRETKEY,

}